<template><br /></template>

<script>
import router from '@/router'

export default {
  name: 'ManagementHome',
  components: {},

  props: {},

  data () {
    return {}
  },

  computed: {},

  watch: {},

  created () {},
  mounted () {
    router.replace({
      name: 'UserList'
    })
  },
  updated () {},
  destroyed () {},

  methods: {}
}
</script>
